"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// import {
//     AiOutlineAlignCenter,
//     AiOutlineAlignLeft,
//     AiOutlineAlignRight,
// } from "react-icons/ai";
// import {
// FaRegFileImage,
// } from "react-icons/fa";
const CustomModal_1 = __importDefault(require("./CustomModal"));
const ImagePicker_1 = __importDefault(require("./ImagePicker"));
function ContentEditableToolBar(props) {
    const [row, setrow] = react_1.default.useState(2);
    const [col, setcol] = react_1.default.useState(2);
    const [image, setimage] = react_1.default.useState('');
    const [width, setwidth] = react_1.default.useState(100);
    return (react_1.default.createElement("div", { className: "d-flex " },
        react_1.default.createElement("button", { className: "btn btn-outline-secondary ms-1", onClick: () => {
                document.execCommand("bold", false);
            } }, "bold"),
        react_1.default.createElement("select", { className: "form-select d-inline w-auto", value: "", onChange: (e) => {
                document.execCommand("fontSize", false, e.target.value);
            } },
            react_1.default.createElement("option", null, "\u062D\u062C\u0645 \u0627\u0644\u0646\u0635"),
            react_1.default.createElement("option", { value: 1 }, "1"),
            react_1.default.createElement("option", { value: 2 }, "2"),
            react_1.default.createElement("option", { value: 3 }, "3"),
            react_1.default.createElement("option", { value: 4 }, "4"),
            react_1.default.createElement("option", { value: 5 }, "5"),
            react_1.default.createElement("option", { value: 6 }, "6"),
            react_1.default.createElement("option", { value: 7 }, "7"),
            react_1.default.createElement("option", { value: 8 }, "8")),
        react_1.default.createElement("button", { className: "btn btn-outline-secondary mx-1", onClick: () => {
                document.execCommand("JustifyRight", false, "");
            } },
            react_1.default.createElement("i", { className: "bi bi-text-right" })),
        react_1.default.createElement("button", { className: "btn btn-outline-secondary", onClick: () => {
                document.execCommand("justifyCenter", false, "");
            } },
            react_1.default.createElement("i", { className: "bi bi-justify" })),
        react_1.default.createElement("button", { className: "btn btn-outline-secondary mx-1", onClick: () => {
                document.execCommand("justifyLeft", false, "");
            } },
            react_1.default.createElement("i", { className: "bi bi-text-left" })),
        react_1.default.createElement("div", { className: "d-inline-flex align-items-center mx-3" },
            react_1.default.createElement("div", { className: "fw-bold" }, "\u0639\u062F\u062F \u0627\u0644\u0627\u0639\u0645\u062F\u0629 :"),
            react_1.default.createElement("input", { className: "form-control me-1", value: row, style: { width: 50 }, type: "number", onChange: (e) => setrow(+e.target.value) }),
            react_1.default.createElement("div", { className: "fw-bold me-3" }, "\u0639\u062F\u062F \u0627\u0644\u0635\u0641\u0648\u0641:"),
            react_1.default.createElement("input", { value: col, style: { width: 50 }, className: "form-control me-1", type: "number", onChange: (e) => setcol(+e.target.value) }),
            react_1.default.createElement("button", { className: "btn btn-secondary mx-3", onClick: () => {
                    let rowsS = "";
                    for (let i = 0; i < row; i++) {
                        rowsS = rowsS + "<td></td>";
                    }
                    let colsS = "";
                    for (let i = 0; i < col; i++) {
                        colsS = colsS + "<tr>" + rowsS + "</tr>";
                    }
                    document.execCommand("insertHTML", false, "<table class='table table-bordered table-striped table-responsive'>" +
                        colsS +
                        "</table>");
                } }, "\u0625\u0636\u0627\u0641\u0629 \u062C\u062F\u0648\u0644")),
        react_1.default.createElement(CustomModal_1.default, { children: (close, show) => react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: 'text-center' },
                    react_1.default.createElement(ImagePicker_1.default, { maxSize: 10 * 1024 * 1024, setImage: base64 => {
                            setimage(base64);
                            document.execCommand("insertHTML", false, "<img style='max-width:" + width + "%' src='" +
                                base64 +
                                "' />");
                            close();
                        } })),
                react_1.default.createElement("div", { className: 'text-center' },
                    react_1.default.createElement("div", { className: 'text-center fs-5 fw-bold' }, "\u062D\u062C\u0645 \u0627\u0644\u0635\u0648\u0631\u0629 %"),
                    react_1.default.createElement("input", { type: 'number', min: 5, max: 100, value: width, onChange: e => {
                            if (+e.target.value <= 100 && +e.target.value >= 5)
                                setwidth(+e.target.value);
                        } }))), buttonClass: 'btn  btn-outline-secondary', icon: react_1.default.createElement("i", { className: "bi bi-file-image" }), label: 'إضافة صورة' })));
}
exports.default = ContentEditableToolBar;
